import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { message } from "../../../actions";
import { createAnswers, patchAnswers } from "../actions/Answers";

import Icon from "../../../components/Icon";
import { patchQuestionnaires } from "../actions/Questionnaires";
import Form from "../../../components/Form";
import QuestionnaireTree from "../components/QuestionnaireTree";
import QuestionnaireEditor from "../components/QuestionnaireEditor";
import TextEditor from "../components/TextEditor";

const mapStateToProps = ( state ) =>
{
	return {
		questionnaires: state.questionnaires,
		blocksByQuestionnaireId: state.blocksByQuestionnaireId
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		patchQuestionnaires: ( formData ) =>
		{
			dispatch( patchQuestionnaires( formData ) );
		},
		postAnswers: ( a_formData, a_questionnaire_id, a_block_id, a_question_id ) =>
		{
			dispatch( createAnswers( a_formData, a_questionnaire_id, a_block_id, a_question_id ) );
		},
		patchAnswers: ( a_formData, a_survey_answer_id, a_question_id, a_block_id, a_questionnaire_id, a_params ) =>
		{
			dispatch( patchAnswers( a_formData, a_survey_answer_id, a_question_id, a_block_id, a_questionnaire_id, a_params ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Antwortenkomponente der GUI
 */
class Answer extends React.Component
{
	constructor( props )
	{
		super( props );
		
		const { blocksByQuestionnaireId, questionnaireId, node } = { ...props };
		const block = node && node.block_id && questionnaireId && blocksByQuestionnaireId ? blocksByQuestionnaireId[questionnaireId][node.block_id] : null;
		const answer = block && block.questions[node.question_id].answers[node.id] ? block.questions[node.question_id].answers[node.id] : null;
		
		this.state = {
			nextAction: !!( answer && answer.next_question_id ),
			next_question_id: answer && answer.next_question_id ? answer.next_question_id : null,
			result_text: answer && answer.result_text ? answer.result_text : null,
			selectedKeys: null,
			saveDisabled: true
		};
		
		this.onSelect = this.onSelect.bind( this );
		this.handleNewAnswer = this.handleNewAnswer.bind( this );
		this.handleType = this.handleType.bind( this );
		this.handleEditForm = this.handleEditForm.bind( this );
		
	} // function constructor(...)
	
	componentDidUpdate( prevProps, prevState, snapshot )
	{
		const { blocksByQuestionnaireId, questionnaireId, node } = { ...this.props };
		
		if ( prevProps.node && node && prevProps.node.id !== node.id )
		{
			const block = node && node.block_id && questionnaireId && blocksByQuestionnaireId ? blocksByQuestionnaireId[questionnaireId][node.block_id] : null;
			const answer = block && block.questions[node.question_id].answers[node.id] ? block.questions[node.question_id].answers[node.id] : null;
			
			this.setState(
				{
					nextAction: !!( answer && answer.next_question_id ),
					next_question_id: answer && answer.next_question_id ? answer.next_question_id : null,
					result_text: answer && answer.result_text ? answer.result_text : null,
					selectedKeys: null,
					saveDisabled: true
				}
			);
		}
		
	} // function componentDidUpdate(...)
	
	/**
	 * Einen Antworttyp ändern
	 *
	 * @param {boolean} a_nextAction Antworttyp Folgeaktion (ja = true)
	 */
	handleType( a_nextAction )
	{
		this.setState( { nextAction: a_nextAction, saveDisabled: false } );
		
	} // function handleType(...)
	
	/**
	 * Gibt die forminhalte der Antwort zurück
	 *
	 * @param {Object} a_answer Inhalte der Antwort
	 */
	getAnswerForm( a_answer )
	{
		const formData = {
			title: a_answer.title,
			question_id: a_answer.question_id,
			sort_id: a_answer.sort_id
		};
		
		// Pflichtfelder prüfen
		if ( a_answer.title.length === 0 )
		{
			this.props.message( "Bitte den Titel eingeben.", "warning", 5000 );
			return false;
		}
		
		if ( this.state.nextAction )
		{
			// Pflichtfelder prüfen
			if ( this.state.next_question_id === null )
			{
				this.props.message( "Bitte die Folgeaktion auswählen.", "warning", 5000 );
				return false;
			}
			
			formData["next_question_id"] = this.state.next_question_id;
		}
		else
		{
			// Pflichtfelder prüfen
			if ( this.state.result_text === null )
			{
				this.props.message( "Bitte den Ergebnistext eingeben.", "warning", 5000 );
				return false;
			}
			
			formData["result_text"] = this.state.result_text;
		}
		
		return formData;
		
	} // function getAnswerForm(...)
	
	/**
	 * Eine neue Antwort speichern
	 *
	 * @param {Object} a_event Button-Event
	 * @param {Object} a_answer Inhalte der Antwort
	 */
	handleNewAnswer( a_event, a_answer )
	{
		const { blocksByQuestionnaireId, questionnaires, isNew, lastSelectedNode, questionnaireId } = { ...this.props };
		
		// Form überprüfen
		const formData = this.getAnswerForm( a_answer );
		if ( formData === false )
		{
			return a_event.preventDefault();
		}
		
		const questions = blocksByQuestionnaireId[questionnaireId][lastSelectedNode.block_id]["questions"];
		switch ( lastSelectedNode.type )
		{
			case "questions":
				formData["question_id"] = lastSelectedNode.id;
				formData["sort_id"] = Object.keys( questions[formData["question_id"]]["answers"] ).length + 1;
				break;
			case "answers":
				formData["question_id"] = lastSelectedNode.question_id;
				// ggf. Umsoritierung festlegen wenn die gewählte Antwort nicht die letzte in der Liste ist
				if ( isNew )
				{
					formData["sort_id"] = QuestionnaireEditor.MAX_SORT_ID;
					formData["new_sort_id"] = parseInt( lastSelectedNode.sortId ) + 1;
				}
				else
				{
					formData["sort_id"] = lastSelectedNode.sortId;
				}
				break;
			default:
				break;
		}
		
		// Wenn der Typ binär ist und bereits 2 Antworten vorliegen, dann sollte der Typ geändert werden
		const questionAnswers = questions[formData["question_id"]]["answers"];
		const binary = questions[formData["question_id"]].binary;
		if ( binary && Object.keys( questionAnswers ).length >= 2 )
		{
			this.props.message( "Bitte den Antworttyp der Frage ändern.", "warning", 5000 );
			return a_event.preventDefault();
		}
		
		this.props.postAnswers( formData, questionnaireId, lastSelectedNode.block_id, formData["question_id"] );
		
		// Fragebogen wieder deaktivieren
		if ( questionnaires[questionnaireId].active === "1" )
		{
			this.props.patchQuestionnaires( { ...questionnaires[questionnaireId], active: "0" } );
		}
		
		this.setState( { saveDisabled: false } );
		
		a_event.preventDefault();
		
	} // function handleNewAnswerSubmit(...)
	
	/**
	 * Antwort ändern
	 *
	 * @param {Object} a_event Button-Event
	 * @param {Object} a_answer Inhalte der Antwort mit Änderungen
	 * @param {Object} a_currentAnswer Inhalte der ursprünglichen Antwort
	 */
	handleEditAnswer( a_event, a_answer, a_currentAnswer )
	{
		const { questionnaires, questionnaireId, node } = { ...this.props };
		
		// Form überprüfen
		const formData = this.getAnswerForm( a_answer );
		if ( formData === false )
		{
			return a_event.preventDefault();
		}
		formData["id"] = a_answer.id;
		
		// Wenn keine Änderungen vorliegen, dann abbrechen
		let isChanged = QuestionnaireEditor.compareNodes( a_currentAnswer, formData );
		if ( !isChanged )
		{
			this.props.message( "Es liegen keine Änderungen vor." );
			this.setState( { saveDisabled: true } );
			
			return a_event.preventDefault();
		}
		
		this.props.patchAnswers( formData, a_answer.id, node.question_id, node.block_id, questionnaireId );
		
		// Fragebogen wieder deaktivieren
		if ( questionnaires[questionnaireId].active === "1" )
		{
			this.props.patchQuestionnaires( { ...questionnaires[questionnaireId], active: "0" } );
		}
		
		return a_event.preventDefault();
		
	} // function handleEditAnswer(...)
	
	/**
	 * Event: Wenn Änderungen vorgenommen werden, dann den Änderungsspeichernbutton aktivieren
	 */
	handleEditForm()
	{
		this.setState( { saveDisabled: false } );
		
	} // function handleEditForm(...)
	
	/**
	 * Ergebnistext ändern
	 *
	 * @param {string} a_html Ergebnistext
	 */
	handleEditAnswerResult( a_html )
	{
		this.setState( { result_text: a_html, selectedKeys: null, saveDisabled: false } );
		
	} // function handleEditAnswerResult(...)
	
	/**
	 * Event: Wenn eine Auswahlt getroffen wird
	 *
	 * @param {string} a_selectedKey Informationen zu der angeklickten Auswahl
	 * @param {string} a_treeNode Informationen zu der angeklickten Auswahl
	 */
	onSelect( a_selectedKey, a_treeNode )
	{
		this.setState( { next_question_id: a_treeNode.node.props.id, selectedKeys: a_selectedKey, saveDisabled: false } );
		
	} // function onSelect(...)
	
	render()
	{
		const { className = null, blocksByQuestionnaireId, questionnaireId, node, lastSelectedNode } = { ...this.props };
		const block = node && node.block_id && questionnaireId && blocksByQuestionnaireId ? blocksByQuestionnaireId[questionnaireId][node.block_id] : null;
		const answer = block && block.questions[node.question_id].answers[node.id] ? block.questions[node.question_id].answers[node.id] : null;
		const placeholder = {};
		
		let questionId = 0;
		switch ( lastSelectedNode.type )
		{
			case "questions":
				questionId = lastSelectedNode.id;
				break;
			case "answers":
				questionId = lastSelectedNode.question_id;
				break;
			default:
				break;
		}
		
		// Wenn der Typ binär ist und bereits 2 Antworten vorliegen, dann sollte der Typ geändert werden
		const currentQuestion = blocksByQuestionnaireId[questionnaireId][lastSelectedNode.block_id]["questions"][questionId];
		if ( !node && currentQuestion.binary && Object.keys( currentQuestion["answers"] ).length >= 2 )
		{
			this.props.message( "Es können keine weiteren Antworten mit dem Fragetyp (Ja|Nein) angelegt werden.", "warning", 5000 );
			// TODO Selektiere die letzte Auswahl
			return <React.Fragment/>;
		}
		
		// Binärfragen Titeldefinition
		if ( currentQuestion.binary )
		{
			if ( answer === null )
			{
				switch ( lastSelectedNode.type )
				{
					case "questions":
						placeholder["title"] = Object.keys( lastSelectedNode["children"] ).filter( a_key => lastSelectedNode["children"][a_key].props.id ).length === 0 ? "Ja" : "Nein";
						break;
					case "answers":
						placeholder["title"] = lastSelectedNode.sortId === "1" ? "Ja" : "Nein";
						break;
					default:
						break;
				}
			}
			else
			{
				answer["title"] = answer.sort_id === "1" ? "Ja" : "Nein";
			}
		}
		
		const treePrefix = "nextAction";
		const props = {};
		const editorProps = {};
		if ( node || lastSelectedNode )
		{
			// Wenn die Antwort bearbeitet wird, oder das zuletzt gewählte Element eine Antwort oder eine Frage ist, dann die Frage Id merken
			props["disabledQuestionId"] = node
				? node.question_id
				: lastSelectedNode.type === "answers"
					? lastSelectedNode.question_id
					: lastSelectedNode.id;
		}
		if ( answer )
		{
			props["selectedKeys"] = this.state.selectedKeys === null ? [ `${treePrefix}-${answer.id}-questions-${answer.next_question_id}` ] : this.state.selectedKeys;
			
			if ( answer.hasOwnProperty( "result_text" ) && answer.result_text )
			{
				editorProps["content"] = answer.result_text;
			}
		}
		
		const additionalFormHtml = this.state.nextAction
			? <React.Fragment>
				<label className={"label-note-editor"}>Folgeaktion:<span className="form-element-required">*</span></label>
				<QuestionnaireTree {...props}
				                   questionnaireId={questionnaireId}
				                   collapseOrExpandAll={"expand"}
				                   showable={[ "blocks", "questions" ]}
				                   disabled={[ "blocks", "answers", "topNode" ]}
				                   onSelect={this.onSelect}
				                   show={"longTree"}
				                   treePrefix={`${treePrefix}-${node ? node.id : lastSelectedNode.id}`}
				/>
			</React.Fragment>
			: <React.Fragment>
				<label className={"label-note-editor"}>Ergebnistext:<span className="form-element-required">*</span></label>
				<TextEditor onSubmit={this.handleEditAnswerResult.bind( this )}
				            className="inactive"
				            {...editorProps}
				/>
			</React.Fragment>;
		
		return <div className={className}>
			{
				node &&
				<div className={"breadcrumb label"}>{node.breadcrumb}</div>
			}
			<h5>{node ? `Antwort ${node.sortId}` : "Neue Antwort"}</h5>
			<label className={"label-note-editor"}>Antworttyp:</label>
			<button className={"btn-flat btn-radio svg secondary-color-text"} onClick={() => this.handleType( true )}>
				<span
					className={`icon-rounded hover-primary-color hover-white-text icon-shadow${this.state.nextAction ? " white-text primary-color" : ""}`}>
					<Icon size={22} verticalAlign={"middle"} iconName={"answerNextQuestion"}/>
				</span>
				<span>Aktion</span>
			</button>
			<button className={"btn-flat btn-radio svg secondary-color-text"} onClick={() => this.handleType( false )}>
				<span
					className={`icon-rounded hover-primary-color hover-white-text icon-shadow${!this.state.nextAction ? " white-text primary-color" : ""}`}>
					<Icon size={22} verticalAlign={"middle"} iconName={"answerQuestionResult"}/>
				</span>
				<span>Ergebnis</span>
			</button>
			{
				answer
					? <Form
						id={"form-edit-answer"}
						submitValue={[ <Icon key={`form-new-answer-icon`} iconName={"edit"}/>, <span key={`form-new-answer-text`}>Antwort ändern</span> ]}
						onSubmit={( event, formData ) => this.handleEditAnswer( event, formData, answer )}
						fields={[
							{
								name: "title",
								title: "Antworttext",
								type: "text",
								required: true,
								className: "padding-right",
								disabled: currentQuestion.binary
							}
						]}
						onChange={this.handleEditForm}
						disabled={this.state.saveDisabled}
						additionalFormHtml={additionalFormHtml}
						values={answer}
					/>
					: <Form
						id={"form-new-answer"}
						submitValue={[ <Icon key={`form-new-answer-icon`} iconName={"add"}/>, <span key={`form-new-answer-text`}>Antwort erstellen</span> ]}
						onSubmit={( event, formData ) => this.handleNewAnswer( event, formData )}
						fields={[
							{
								name: "title",
								title: "Antworttext",
								type: "text",
								required: true,
								className: "padding-right",
								disabled: currentQuestion.binary
							}
						]}
						values={placeholder}
						additionalFormHtml={additionalFormHtml}
					/>
			}
		</div>;
		
	} // function render()
	
} // class

Answer.propTypes = {
	className: PropTypes.string,
	node: PropTypes.object,
	isNew: PropTypes.bool,
	questionnaireId: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ),
	lastSelectedNode: PropTypes.object
};

Answer = connect(
	mapStateToProps,
	mapDispatchToProps
)( Answer );

export default Answer;